import { Action } from '@ngrx/store';
import { TocResponse } from '@cemex-core/cmx-api/models/sales-area/toc-response';

export enum OneClickTermsAndConditionctionTypes {
  LOAD_TERMS_AND_CONDITIONS = '[One Click] Load terms and conditions',
  LOAD_TERMS_AND_CONDITIONS_DOCUMENTS = '[One Click] Load terms and conditions documents',
  LOAD_TERMS_AND_CONDITIONS_COMPLETE = '[One Click] Load terms and conditions completed',
  RESET = '[One Click] terms and conditions reset',
}

export class OneClickLoadTermsAndConditionsAction implements Action {
  readonly type = OneClickTermsAndConditionctionTypes.LOAD_TERMS_AND_CONDITIONS;

  constructor() {}
}

export class OneClickLoadTermsAndConditionsCompleteAction implements Action {
  readonly type = OneClickTermsAndConditionctionTypes.LOAD_TERMS_AND_CONDITIONS_COMPLETE;

  constructor(public payload: TocResponse) {}
}

export class OneClickLoadTermsAndConditionsDocumentsAction implements Action {
  readonly type = OneClickTermsAndConditionctionTypes.LOAD_TERMS_AND_CONDITIONS_DOCUMENTS;

  constructor() {}
}

export class OneClickResetTermsAndConditionsAction implements Action {
  readonly type = OneClickTermsAndConditionctionTypes.RESET;

  constructor(public payload: string) {}
}

export type OneClickTermsAndConditionsActions =
  | OneClickLoadTermsAndConditionsAction
  | OneClickLoadTermsAndConditionsDocumentsAction
  | OneClickLoadTermsAndConditionsCompleteAction
  | OneClickResetTermsAndConditionsAction;
